import { Route, Switch, Redirect } from "react-router-dom";
import { Login } from "./Login";
import { Register } from "./Register";
import { ForgetPassword } from "./ForgetPassword";
import { UserInfo } from "./UserInfo";
import { useStyles } from "./styles";
import Div100vh from "react-div-100vh";
import { createContext, useState } from "react";
import { useTheme } from "react-jss";
import classNames from "classnames";
export const authenticationContext = createContext();

const Authentication = () => {
  const [counter, setCounter] = useState(0);
  const theme = useTheme();
  const styles = useStyles({ theme });
  const [otpRequested, setOtpRequested] = useState(false);
  const [cellnum, setCellnum] = useState("");
  const { isSaderatCustomization } = JSON.parse(
    sessionStorage.getItem("config")
  );

  return (
    <Div100vh>
      <authenticationContext.Provider
        value={{
          counter,
          setCounter,
          otpRequested,
          setOtpRequested,
          cellnum,
          setCellnum,
        }}
      >
        <div className={styles.containerLogin100}>
          <div className={styles.wrapLogin100}>
            <div className={styles.logosBox}>
              {isSaderatCustomization && (
                <div alt="logo" className={styles.bsiLogo} />
              )}
              <div className={classNames(styles.login100Pic)} data-tilt></div>
              <div alt="logo" className={styles.smallPageLogo} />
            </div>
            <Switch>
              <Route path="/login" component={Login} />
              <Route path="/register" component={Register} />
              <Route path="/forget-password" component={ForgetPassword} />
              <Route path="/user-info" component={UserInfo} />
              <Redirect to="/login" />
            </Switch>
          </div>
        </div>
        <div className={styles.appVersion}>
          v - {" " + process.env.REACT_APP_VERSION}
        </div>
      </authenticationContext.Provider>
    </Div100vh>
  );
};

export { Authentication };
